import { Button } from "@/components/design-system/button";
import { formatInr, getCourseTotal } from "../utils/landingPricing";
import type { LandingCourse } from "../types/landing.types";

interface StickyEnrollBarProps {
  course: LandingCourse;
  onEnroll: () => void;
}

export default function StickyEnrollBar({ course, onEnroll }: StickyEnrollBarProps) {
  const total = getCourseTotal(course);

  return (
    <div className="fixed bottom-0 left-0 right-0 z-30 rounded-t-[10px] border-t border-landing-border bg-white px-4 py-3 shadow-[0px_-4px_16px_rgba(0,0,0,0.08)] md:hidden">
      <div className="mx-auto flex max-w-[520px] items-center justify-between gap-4">
        <div>
          <p className="text-[18px] font-bold leading-[24px] text-landing-text">
            {formatInr(total)}
          </p>
          <p className="text-[11px] leading-[16px] text-landing-muted">
            (Inclusive of all taxes)
          </p>
        </div>
        <Button
          type="button"
          variant="primary"
          className="h-[48px] min-w-[140px] rounded-[12px] bg-landing-button px-6 text-[16px] font-semibold hover:bg-landing-button-hover"
          onClick={onEnroll}
        >
          Enroll Now
        </Button>
      </div>
    </div>
  );
}
